/* eslint-disable no-console */
const containerId = 'klf-donations__form-container';
const URL_PARAMS = {
  HASH: 'hash',
  INIT: 'init',
  AMOUNT: 'amount',
  AMOUNT_FIX: 'amount_fix',
  PROJECT_ID: 'projectid',
  PROJECT_ID_FIX: 'fb_project_id_fix',
  CONTAINER_ID: 'containerId',
} as const;
const INIT_TRUE = 'true' as const;

type Args = {
  hash: string;
  projectId: string | null;
  amount: string | null;
};

function buildSrc({ hash, projectId, amount }: Args) {
  const params = new URLSearchParams({
    [URL_PARAMS.HASH]: hash,
    [URL_PARAMS.CONTAINER_ID]: containerId,
  });

  if (amount) params.set(URL_PARAMS.AMOUNT_FIX, amount);
  if (projectId) params.set(URL_PARAMS.PROJECT_ID_FIX, projectId);

  return `https://secure.fundraisingbox.com/app/paymentJSdynamic?${params.toString()}`;
}

function renderScript(args: Args) {
  const $fbScript = document.createElement('script');

  $fbScript.type = 'text/javascript';
  $fbScript.src = buildSrc(args);

  const $container = document.getElementById(containerId);

  if (!$container) {
    console.error('Could not find container');
    return;
  }

  $container.innerHTML = '';
  $container.appendChild($fbScript);

  $container.dataset.fbMounted = 'true';

  setTimeout(() => {
    $container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 500);
}

function checkAmount(amount: string): string | null {
  if (amount === 'custom') {
    return null;
  }

  const amountNumber: number | null = parseInt(amount, 10);

  if (Number.isNaN(amountNumber)) {
    console.warn("donation value amount is neither number nor 'custom'");

    return null;
  }

  return String(amountNumber);
}

function reloadPage(args: Args) {
  const params = new URLSearchParams({
    [URL_PARAMS.INIT]: INIT_TRUE,
  });

  if (args.amount) params.set(URL_PARAMS.AMOUNT, args.amount);
  if (args.projectId) params.set(URL_PARAMS.PROJECT_ID, args.projectId);

  window.location.href = `${window.location.pathname}?${params.toString()}`;
}

function handleButtonClick(args: Args) {
  const $container = document.getElementById(containerId);

  if (!$container) {
    console.error('Could not find container');
    return;
  }

  if ($container.dataset.fbMounted) {
    reloadPage(args);
    return;
  }

  renderScript(args);
}

document.querySelectorAll('.klf-donations').forEach(($el) => {
  const url = new URL(window.location.href);
  const { hash } = ($el as HTMLElement).dataset;
  const isInit = url.searchParams.get(URL_PARAMS.INIT) === INIT_TRUE;
  const amount = url.searchParams.get(URL_PARAMS.AMOUNT);
  const projectId = url.searchParams.get(URL_PARAMS.PROJECT_ID);

  if (!hash) {
    console.error('Could not get hash from data attribute');
    return;
  }

  if (isInit) {
    renderScript({
      hash,
      projectId,
      amount: amount ? checkAmount(amount) : null,
    });
  }

  const donationOptions = $el.querySelectorAll('.js-klf-donations');

  donationOptions.forEach(($do) => {
    const donationValue = $do.getAttribute('data-donation-value');

    if (!donationValue) {
      console.error('Could not find donation value');
      return;
    }

    const $donationButton = $do.querySelector('.js-button');

    if (!$donationButton) {
      console.error('Could not find donation button');
      return;
    }

    $donationButton.addEventListener('click', () => {
      handleButtonClick({
        hash,
        projectId,
        amount: checkAmount(donationValue),
      });
    });
  });
});
